import React, { useState, useEffect, useCallback, useMemo } from "react";
import AdminHeadListing from "../../components/admin/AdminHeadListing";
import AdminHeadService from "../../services/admin/AdminHeadService";
import AdminUserService from "../../services/admin/AdminUserService";
import { showErrorToast } from "../../utils/AlertUtils";
import { useLoading } from "../../context/LoadingContext";
import guLocale from "../../locales/gu";

const AdminHead = () => {
  const locale = guLocale.admin.head;
  const { setIsLoading } = useLoading();
  const [filterText, setFilterText] = useState(""); // State for filter text
  const [data, setData] = useState([]);
  const [userData, setUserData] = useState([]);
  const headFilterOptions = { showHeads: false, showUsers: true };
  const isFilterVisible = true;
  const [selectedFilters, setSelectedFilters] = useState({ user: [], head: [] });

  const fetchAll = useCallback(async () => {
    try {
      setIsLoading(true);
      const [usersRes, headsRes] = await Promise.all([
        AdminUserService.getUsers(),
        AdminHeadService.getHeads(),
      ]);
      if (usersRes && usersRes.statusCode === 200) {
        setUserData(usersRes.data);
      }
      if (headsRes && headsRes.statusCode === 200) {
        setData(headsRes.data);
      }
    } catch (error) {
      console.error("Error fetching data", error);
      showErrorToast(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  const columns = [
    {
      name: locale.headNameLabel,
      selector: (row) => row.head_name,
      sortable: true,
    },
    {
      name: locale.aprilOpeningBalanceCashLabel,
      selector: (row) => row.opening_balance_cash,
    },
    {
      name: locale.aprilOpeningBalanceBankLabel,
      selector: (row) => row.opening_balance_bank,
    },
  ];

  // const filteredData = useMemo(() => {
  //   return data.filter((item) =>
  //     Object.values(item).some((value) =>
  //       value.toString().toLowerCase().includes(filterText.toLowerCase())
  //     )
  //   );
  // }, [data, filterText]);
  const filteredData = useMemo(() => {
    return data.filter((item) => {
      // 1️⃣ Text Search Filter
      const matchesSearch = Object.values(item)
        .some((value) => value?.toString().toLowerCase().includes(filterText.toLowerCase()));

      // 2️⃣ User Filter
      const matchesUser = selectedFilters.user.length === 0 || 
        selectedFilters.user.some((u) => u.value === item.user_id);

      return matchesSearch && matchesUser;
    });
  }, [data, filterText, selectedFilters]);

  const handleFilterChange = useCallback((e) => {
    setFilterText(e.target.value); // Only update filterText state
  }, []);

  const handleApplyFilters = useCallback((filterArrays) => {
    setSelectedFilters(filterArrays);
  }, []);

  return (
    <div>
      <AdminHeadListing
        columns={columns}
        data={filteredData}
        filterText={filterText}
        handleFilterChange={handleFilterChange}
        headFilterOptions={headFilterOptions}
        isFilterVisible={isFilterVisible}
        userData={userData}
        handleApplyFilters={handleApplyFilters}
      />
    </div>
  );
};

export default AdminHead;
